import { render, staticRenderFns } from "./allsettings.vue?vue&type=template&id=562be345&scoped=true"
import script from "./allsettings.vue?vue&type=script&lang=js"
export * from "./allsettings.vue?vue&type=script&lang=js"
import style0 from "./allsettings.vue?vue&type=style&index=0&id=562be345&prod&lang=scss"
import style1 from "./allsettings.vue?vue&type=style&index=1&id=562be345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562be345",
  null
  
)

export default component.exports